module.exports = __webpack_public_path__ + "static/media/sub_ris_ass.78d55356.png";